import React from 'react';
import { CheckCircle2Icon, LockIcon, MailIcon, ShieldCheckIcon } from 'lucide-react';
import { GoldPlaque } from '../ui/GoldPlaque';
import { CtaButton } from '../ui/CtaButton';
import { HeroMockup } from '../product/HeroMockup';
import { heroInclusions, heroTrust } from '../../data/site';
const trustIcons = {
  lock: LockIcon,
  mail: MailIcon,
  shield: ShieldCheckIcon
};
export function Hero() {
  return <section id="hero" aria-labelledby="hero-title" className="sport-hero relative overflow-hidden border-t-4 border-gold bg-ink text-white" data-id="element-30" data-mp="374xpswvsamyo">
      <div className="relative z-10 mx-auto grid max-w-page items-center gap-10 px-5 pb-16 pt-6 sm:pt-14 lg:grid-cols-[1.02fr_0.98fr] lg:px-8 lg:pb-24 lg:pt-16" data-id="element-31" data-mp="3c76kpys7vz3f">
        <div className="text-center lg:text-left" data-id="element-32" data-mp="3l4qlz7q2xve1">
          <GoldPlaque data-id="element-33" data-mp="1mq5iyzbjh4ib">Ready-to-teach school handball</GoldPlaque>
          <h1 id="hero-title" className="mt-6 font-display text-[36px] font-bold uppercase leading-[0.98] min-[400px]:text-[40px] sm:text-[56px] lg:text-[68px]" data-id="element-34" data-mp="1mrqeos9lathr">
            Your next 12 handball lessons. <span className="text-gold" data-id="element-35" data-mp="230ezttwg7lt9">Already planned.</span>
          </h1>

          {/* First screen on mobile: title → mockup → button to the offer */}
          <div className="mt-5 lg:hidden" data-id="element-36" data-mp="1t9kc0l3k0e5p">
            <HeroMockup data-id="element-37" data-mp="1o9pj6c07xei0" />
          </div>

          <div className="mt-6 lg:mt-8" data-id="element-38" data-mp="1oaqw6m0sob2d">
            <CtaButton target="offer" className="w-full sm:w-auto" data-id="element-39" data-mp="1o7l7h7w2vb76">
              Get the lesson pack
            </CtaButton>
          </div>

          <p className="mx-auto mt-7 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg lg:mx-0 lg:mt-7" data-id="element-40" data-mp="2gxto2vaytnjn">
            Twelve complete 40-minute team handball lessons for ages 8–11. Open the plan, set up the space, and teach
            with clear diagrams, timings and instructions.
          </p>

          <ul aria-label="What you get" className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2.5 lg:justify-start" data-id="element-41" data-mp="10kdarecptagr">
            {heroInclusions.map(item => <li key={item} className="flex items-center gap-1.5 text-base font-bold" data-id="element-42" data-mp="3jqz6zt929k1u">
                <CheckCircle2Icon aria-hidden="true" className="h-[18px] w-[18px] text-gold" data-id="element-43" data-mp="3jp4kiai55jvn" />
                {item}
              </li>)}
          </ul>

          <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-44" data-mp="39s9opzd95xl2">
            {heroTrust.map(item => {
            const Icon = trustIcons[item.icon];
            return <li key={item.label} className="flex items-center gap-1.5 text-sm text-white/75" data-id="element-45" data-mp="301ov6qcfrj90">
                  <Icon aria-hidden="true" className="h-4 w-4 text-gold" data-id="element-46" data-mp="34uztg336mrpb" />
                  {item.label}
                </li>;
          })}
          </ul>
        </div>

        <div className="hidden lg:block" data-id="element-47" data-mp="2w1wic1g0eqxu">
          <HeroMockup data-id="element-48" data-mp="2h443lbiae6kp" />
        </div>
      </div>
    </section>;
}